import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Badge,
  Select,
  Stack,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { updateDriverStatusAction, fetchDriversAction } from 'state/actions/driverActions';
import { useCustomNotification } from 'components/Toasts/OpenNotification';
import ReusableDrawer from '../../../../components/Drawers/ReusableDrawer.js';
import GradientButton from 'components/Buttons/GradientButton.js';
import ReusableInput from 'components/Inputs/ReusableInput';
import headerImage from '../../../../assets/img/background.png';

const EditDriverDrawer = ({ driver, isOpen, onClose }) => {
  const notify = useCustomNotification();
  const dispatch = useDispatch();

  const [status, setStatus] = useState(driver?.driver?.status || '');
  const [reason, setReason] = useState('');

  useEffect(() => {
    setStatus(driver?.driver?.status || '');
  }, [driver]);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleSave = async () => {
    try {
      const response = await dispatch(
        updateDriverStatusAction(driver?.driver?.driver_id, status, reason)
      );
      

      if (response.success) {
        notify({
          message: 'Driver Status Updated',
          description: `Status changed to "${status}"`,
          type: 'success',
        });
        onClose();
        dispatch(fetchDriversAction());
      } else {
        notify({
          message: 'Failed to Update Status',
          description: response.error || 'An error occurred while updating status.',
          type: 'error',
        });
      }
    } catch (error) {
      notify({
        message: 'Error',
        description: error.message || 'Something went wrong while updating the status.',
        type: 'error',
      });
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Edit Driver Status</h2>}
      bodyContent={
        <Box>
          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">Current Status</Text>
          <Badge
            colorScheme={
              status === 'Approved' ? 'green' :
                status === 'Pending' ? 'yellow' :
                  status === 'Suspended' ? 'red' :
                    status === 'Rejected' ? 'orange' :
                      status === 'Deactivated' ? 'purple' :
                        'gray'
            }
            mb={4}
            borderRadius="md"
          >
            {status}
          </Badge>


          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">Update Status</Text>
          <Select
            placeholder="Select status"
            value={status}
            onChange={handleStatusChange}
            mb={4}
          >
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Suspended">Suspended</option>
            <option value="Deactivated">Deactivated</option>
            <option value="Rejected">Rejected</option>
          </Select>

          {/* ReusableInput for reason */}
          <ReusableInput
            label="Reason for Status Change"
            placeholder="Provide a brief reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            type= "textarea"
          />
        </Box>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">Cancel</GradientButton>
          <GradientButton onClick={handleSave} fontSize="15px" width="100px" height="40px">Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default EditDriverDrawer;
